import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useToasts } from '../../../cdl/Toast/useToasts';
import { deleteVesselBudget } from '../../../common/api/clients/vesselBudgets.api';
import { queries } from '../../../common/api/queryKeys/queries';
import { translate } from '../../../common/helpers/translate.helper';

export const useVesselBudgetDelete = (vesselId) => {
    const queryClient = useQueryClient();
    const { addToast, addErrorToast } = useToasts();

    return useMutation({
        mutationFn: deleteVesselBudget,
        onSuccess: () => {
            queryClient.removeQueries({ queryKey: queries.vessels.detail(vesselId)._ctx.budgets.queryKey });

            addToast(translate('budgets.toast.deleteBudget.success'));
        },
        onError: () => {
            addErrorToast(translate('budgets.toast.deleteBudget.error'));
        },
    });
};
